import { render, staticRenderFns } from "./ModalScharffRealPlaza.vue?vue&type=template&id=15778e32&scoped=true&"
import script from "./ModalScharffRealPlaza.vue?vue&type=script&lang=js&"
export * from "./ModalScharffRealPlaza.vue?vue&type=script&lang=js&"
import style0 from "./ModalScharffRealPlaza.vue?vue&type=style&index=0&id=15778e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15778e32",
  null
  
)

export default component.exports